export const SET_DADOS_INICIAIS_DADOS_BANCARIOS = "SET_DADOS_INICIAIS_DADOS_BANCARIOS";
export const LOADING_DADOS_INICIAIS_DADOS_BANCARIOS = "LOADING_DADOS_INICIAIS_DADOS_BANCARIOS";
export const ERROR_DADOS_INICIAIS_DADOS_BANCARIOS = "ERROR_DADOS_INICIAIS_DADOS_BANCARIOS";

export const SET_DADOS_INICIAIS_TIPO_CONTA_BANCARIA = "SET_DADOS_INICIAIS_TIPO_CONTA_BANCARIA";
export const LOADING_DADOS_INICIAIS_TIPO_CONTA_BANCARIA = "LOADING_DADOS_INICIAIS_TIPO_CONTA_BANCARIA";
export const ERROR_DADOS_INICIAIS_TIPO_CONTA_BANCARIA = "ERROR_DADOS_INICIAIS_TIPO_CONTA_BANCARIA";

export const HANDLE_CHANGE_DADOS_BANCO = "HANDLE_CHANGE_DADOS_BANCO";
export const HANDLE_CHANGE_DADOS_TIPO_CONTA = "HANDLE_CHANGE_DADOS_TIPO_CONTA";

export const CHANGE_DADOS_INICIAIAS_DADOS_BANCARIOS_VALUE_FORM = "CHANGE_DADOS_INICIAIAS_DADOS_BANCARIOS_VALUE_FORM";

export const SET_DADOS_INICIAIS_DADOS_TYPEHEADER_BANCO = "SET_DADOS_INICIAIS_DADOS_TYPEHEADER_BANCO";